<template>
  <div class="home-box">
    <div class="top-border"></div>
    <div class="head">
      <div class="head-bg">
          <div class="title-block"></div>
          <h1 v-if="$store.state.user.logo" class="logo"><img :src="$store.state.user.logo" />{{$store.state.user.title}}</h1>
          <h1 v-else class="logo">{{$store.state.user.title}}</h1>
          <div class="title-block right"></div>
      </div>
    </div>
    <div class="mian-bg"></div>
    <div class="bottom-bg"></div>
    <div class="home-bg">
      <div class="map_gai_s"></div>
      <div class="map_gai_r"></div>
      <div class="map_gai_b"></div>
      <div class="map_gai_l"></div>
      <bg-gmap v-if="$i18n.locale==='en-US'"></bg-gmap>
      <bg-amap v-else></bg-amap>
    </div>
    <!-- <div v-if="$i18n.locale==='zh-CN'" class="head_bar_left">
      <img :src="require('../../assets/home_images/weather/myicon/' + weatherData.wea_img +'.png')" class="wea_icon"/>
      <span class="wea_text">{{weatherData.wea}}</span>
      <span>{{weatherData.tem_night}}℃～{{weatherData.tem_day}}℃</span>
      <span>{{weatherData.win}}{{weatherData.win_speed}}</span>
      <img src="@/assets/home_images/head_point.png" class="point" />
      <span class="city">{{weatherData.city}}</span>
    </div> -->
    <div class="head_bar_right">
      <div class="date-box">
        <div class="time">{{nowDate.hour}}:{{nowDate.minute}}:{{nowDate.second}}</div>
        <div class="week-date">
          <span class="week">{{nowDate.week}}</span>
          <span class="date">{{nowDate.year}}.{{nowDate.month}}.{{nowDate.day}} </span>
        </div>
      </div>
      <div class="go-system" @click="$router.push('/device/lamps')">
        {{$t("other.goSystem")}} <span>></span>
      </div>
    </div>
    
    <div class="home-left">
      <div class="home_pad">
        <div class="main-left-top">
          <div class="main-title">
            <h3 class="text">{{$t("home.box1.title")}}</h3>
            <img src="@/assets/home_images/title_sanjiao.png" class="sanjiao" />
          </div>
          <box1 :itemData="resData.lamp" :camera="resData.camera.all_number" :ip="resData.ip.total" :alarm="resData.one_key.total"></box1>
        </div>
        <div class="main-left-cen">
          <div class="main-title">
            <h3 class="text">{{$t("home.box2.title")}}</h3>
            <img src="@/assets/home_images/title_sanjiao.png" class="sanjiao" />
          </div>
          <box2 :itemData="resData.ip"></box2>
        </div>
        <div class="main-left-bot">
          <div class="main-title">
            <h3 class="text">{{$t("home.box3.title")}}</h3>
            <img src="@/assets/home_images/title_sanjiao.png" class="sanjiao" />
          </div>
          <box3 :itemData="resData.camera"></box3>
        </div>
      </div>
    </div>
    <div class="home-right">
      <div class="home_pad">
        <div class="main-right-top">
          <div class="main-title">
            <h3 class="text">{{$t("home.box4.title")}}</h3>
            <img src="@/assets/home_images/title_sanjiao.png" class="sanjiao" />
          </div>
          <box4 :itemData="resData.env" :lamp_name="resData.lamp.name"></box4>
        </div>
        <div class="main-right-cen">
          <div class="main-title">
            <h3 class="text">{{$t("home.box5.title")}}</h3>
            <img src="@/assets/home_images/title_sanjiao.png" class="sanjiao" />
          </div>
          <box5 :itemData="resData.screen"></box5>
        </div>
        <div class="main-right-bot">
          <div class="main-title">
            <h3 class="text">{{$t("home.box6.title")}}</h3>
            <img src="@/assets/home_images/title_sanjiao.png" class="sanjiao" />
          </div>
          <box6 :itemData="resData.alarm"></box6>
        </div>
      </div>
    </div>

    
  </div>
</template>
<script>
// import axios from 'axios'
import systemPublicApi from "@/api/system/public";
import box1 from "@/components/home/box1.vue";
import box2 from "@/components/home/box2.vue";
import box3 from "@/components/home/box3.vue";
import box4 from "@/components/home/box4.vue";
import box5 from "@/components/home/box5.vue";
import box6 from "@/components/home/box6.vue";
import bgAmap from "./bgAmap.vue";
import bgGmap from "./bgGmap.vue";
export default {
  components: {
    box1,
    box2,
    box3,
    box4,
    box5,
    box6,
    bgAmap,
    bgGmap
  },
  data() {
    return {
      resData: {
        lamp: {
          total: 0,
          online: 0,
          malfunction: 0,
          lamp_light: 0,
          light: 1,
          voltage: 220,
          current: 1,
          power: 220,
          lamp_id: 2,
          colorTemperature: 25,
          cost_electricity: 100,
          total_electricity: 2645.5,
          save_electricity: 2568.06,
          name: '默认灯杆',
          Power_factor: 0.0000039
        },
        camera: {
          number:'',
          channel: 1,
          all_number: 0,
          online_number: 0
        },
        env: [],
        ip: {
          total: 0,
          online: 0,
          Offline: 0
        },
        manhole: {
          total: 0,
          online: 0,
          Offline: 0,
          warning: 0
        },
        one_key: {
          total: 0,
          online: 0,
          Offline: 0
        },
        screen: {
          total: 0,
          program: 0,
          url: []
        },
        alarm: []
      },
      lampInfo: {
        name: "",
        lamp_id: "",
        stg_id: "",
        stg_name: "",
        light: "",
        ms: "",
        sb: [],
        camera_list: [],
      },
      
      weatherData: {
        nums:	246,
        cityid:	"101190101",
        city:	"南京",
        date:	"2022-05-25",
        week:	"星期三",
        update_time: "14:00",
        wea: "多云",
        wea_img: "yun",
        tem: "29",
        tem_day: "31",
        tem_night:"20",
        win: "东风",
        win_speed: "2级",
        win_meter: "6km/h",
        air: "58",
        pressure: "1004",
        humidity: "48%"
      },
      nowDate: {
        year: '',
        month: '',
        day: '',
        week: '',
        hour: '',
        minute: '',
        second: '',
      },
      timer: null,
      timer2: null,
      timer3: null
    };
  },
  methods: {
    getData() {
      //获得首页数据
      systemPublicApi.systemIndex().then((res) => {
        if (res.data.code === 1000) {
          this.resData = res.data.data;
        }
      });
    },
    // getNowTemp() {
    //   const that = this
    //   const url = 'https://weather.qyltd.com/free/day/index.php?appid=31736539&appsecret=mcKVlC8B&unescape=1'
    //   axios({
    //     method: 'get',
    //     url: url
    //   }).then(function(res) {
    //     if(res&&res.data.code===1000){
    //       that.weatherData = res.data.data
    //     }
    //   })
    // },
    formatDate() {
      let date = new Date();
      let year = date.getFullYear(); // 年
      let month = date.getMonth() + 1; //月
      let day = date.getDate(); // 日
      let week = date.getDay(); // 星期
      let weekArr = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      let hour = date.getHours(); // 时
      hour = hour < 10 ? "0" + hour : hour; // 如果只有一位，则前面补零
      let minute = date.getMinutes(); // 分
      minute = minute < 10 ? "0" + minute : minute; // 如果只有一位，则前面补零
      let second = date.getSeconds(); // 秒
      second = second < 10 ? "0" + second : second; // 如果只有一位，则前面补零
      this.nowDate = {
        year: year,
        month: month,
        day: day,
        week: weekArr[week],
        hour: hour,
        minute: minute,
        second: second
      }
    }
    
  },
  mounted() {
    // 下面为制作定时器（首页模块数据）
    this.getData();
    if (this.timer) {
      clearInterval(this.timer);
    } else {
      this.timer = setInterval(() => {
        setTimeout(this.getData(), 0);
      }, 6 * 1000);
    }

    // 下面为制作定时器（倒计时）
    this.formatDate();
    if (this.timer2) {
      clearInterval(this.timer2);
    } else {
      this.timer2 = setInterval(() => {
        setTimeout(this.formatDate(), 0);
      }, 500);
    }

    // 下面为制作定时器（天气预报）
    // this.getNowTemp()
    // if (this.timer3) {
    //   clearInterval(this.timer3)
    // } else {
    //   this.timer3 = setInterval(() => {
    //     setTimeout(this.getNowTemp(), 0)
    //   }, 60 * 1000)
    // }
  },
  beforeDestroy() {
    clearInterval(this.timer)
    this.timer = null

    clearInterval(this.timer2)
    this.timer2 = null

    clearInterval(this.timer3)
    this.timer3 = null
    
  }
};
</script>
<style lang='less'>
@color-primary:#9ae3fb;
.home-box {
  position: relative;
  width: 100%;
  height: 100%;
  background: #050a0d;
  .top-border{
    width: 100%;
    height: 41px;
    position: absolute;
    top:0;
    z-index: 1;
    left:0;
    background: url(../../assets/home_images/top_border.png) 0 0 no-repeat;
    background-size: 100% auto;
  }
  .head {
    position: absolute;
    height: 66px;
    left: 0;
    top: 35px;
    width: 100%;
    z-index: 999;
    background: url(../../assets/home_images/title_border.png) 0 100% no-repeat;
    background-size: 100% auto;
    .head-bg {
      height: 76px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-bottom: 30px;
      box-sizing: border-box;
      .title-block{
        width:440px;
        height:24px;
        background: url(../../assets/home_images/title-left.png) right center no-repeat;
        background-size: 100% 100%;
        &.right{
          background: url(../../assets/home_images/title-right.png) left center no-repeat;
          background-size: 100% 100%;
        }
      }
      h1.logo{
        font-size: 30px;
        color: @color-primary;
        font-weight: 600;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 20px 2px;
        letter-spacing: 1px;
        img{
          margin-right: 10px;
          margin-bottom: 2px;
          height:40px;
        }
      }
    }

    
  }

  .head_bar_left{
    position: absolute;
    left:52px;
    top:32px;
    height:52px;
    z-index: 1000;
    display: flex;
    align-items: center;
    img.wea_icon{
      width:auto;
      height:24px;
      margin-top:-2px;
    }
    img.point{
      width:auto;
      height:22px;
      margin-left:60px;
    }
    span{
      margin-left: 20px;
      color:#fff;
      font-size:14px;
      font-family: Bahnschrift, Arial, sans-serif;
    }
    .wea_text{
      margin-left: 4px;
    }
    .city{
      margin-left:2px;
    } 
  }

  .head_bar_right{
    position: absolute;
    top:30px;
    right:52px;
    height:54px;
    z-index: 1000;
    display: flex;
    align-items: center;
    .date-box{
      display: flex;
      align-items: center;
      font-family: Bahnschrift, Arial, sans-serif;
      color:@color-primary;
      .week-date{
        margin-left: 12px;
        .week,.date{
          display: block;
          font-size: 12px;
          line-height: 1;
        }
      }
      .time{
        font-size:32px;
        margin-top: 1px;
      }
    }
    .go-system {
      margin-left: 30px;
      margin-top: 4px;
      cursor: pointer;
      display: flex;
      align-items: center;
      font-size:18px;
      color:@color-primary;
      span {
        font-family: simsun;
        margin-left: 10px;
      }
    }
    
  }

  .mian-bg{
    position: absolute;
    left: 0;
    top: 101px;
    bottom: 75px;
    width: 100%;
    z-index: 0;
    background: url(../../assets/home_images/bg.gif) center top repeat-y;
    background-size: 100% auto;
  }
  .bottom-bg{
    position: absolute;
    left: 0;
    height:54px;
    bottom: 21px;
    width: 100%;
    z-index: 4;
    background: url(../../assets/home_images/bottom_bg.png) center top repeat-y;
    background-size: 100% auto;
  }

  
  .main-title{
      width:100%;
      height: 36px;
      background: url(../../assets/home_images/title_bg.png) left bottom repeat-x;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .text{
        font-weight: bold;
        font-size: 18px;
        color:#fff;
        .sanjiao{
          height:36px;
          width: auto;
        }
      }
    }
  .home-left {
    position: absolute;
    width: 380px;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 9;
    .home_pad {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      padding-top: 90px;
      padding-left: 50px;
      padding-bottom: 47px;
      position: relative;
      overflow: hidden;
      .main-left-top {
        padding: 15px 0;
        height: 37%;
        box-sizing: border-box;
        overflow: hidden;
      }
      .main-left-cen {
        padding: 15px 0;
        height: 30%;
        box-sizing: border-box;
        overflow: hidden;
      }
      .main-left-bot {
        padding: 15px 0;
        height: 33%;
        box-sizing: border-box;
        overflow: hidden;
      }
    }
  }
  .home-right {
    position: absolute;
    width: 380px;
    height: 100%;
    right: 0;
    top: 0;
    z-index: 9;
    .home_pad {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      padding-top: 90px;
      padding-right: 30px;
      padding-bottom: 47px;
      position: relative;
      overflow-y: hidden;
      
      .main-right-top {
        padding: 15px 0;
        height: 33%;
        box-sizing: border-box;
        overflow: hidden;
      }
      .main-right-cen {
        padding: 15px 0;
        height: 30%;
        box-sizing: border-box;
        overflow: hidden;
      }
      .main-right-bot {
        padding: 15px 0;
        height: 37%;
        box-sizing: border-box;
        overflow: hidden;
      }
    }
  }

  .home-bg {
    position: absolute;
    top:70px;
    left:350px;
    right:350px;
    bottom:0px;
    overflow: hidden;
    background: none;
    z-index: 3;
    .map_gai_s{
      width:100%;
      height:177px;
      position: absolute;
      left:0;
      top:0;
      background-position: 0 0;
      background-repeat: repeat-x;
      background-image: url(../../assets/home_images/map_gai_s.png);
      z-index: 2;
    }
    .map_gai_r{
      width:250px;
      height:100%;
      position: absolute;
      right:0;
      bottom:0;
      top:0;
      background-size: 100% auto;
      background-image: url(../../assets/home_images/map_gai_r.png);
      background-position: repeat-y;
      z-index: 2;
    }
    .map_gai_b{
      width:100%;
      height:177px;
      position: absolute;
      left:0;
      bottom:0;
      background-size: auto 100%;
      background-image: url(../../assets/home_images/map_gai_b.png);
      background-position: repeat-x;
      z-index: 2;
    }
    
    .map_gai_l{
      width:250px;
      height:100%;
      position: absolute;
      left:0;
      bottom:0;
      top:0;
      background-size: 100% auto;
      background-image: url(../../assets/home_images/map_gai_l.png);
      z-index: 2;
      background-position: repeat-y;
    }
  }
}
</style>